import type { CardId } from '../../../../model/types';

export const CARD_FOCUS = 'state.actions.cards.focus.CARD_FOCUS' as const;

export type CardFocus = {
	type: typeof CARD_FOCUS;
	payload: {
		cardId: CardId;
	};
};

export const cardFocus = (cardId: CardId) => ({
	type: CARD_FOCUS,
	payload: {
		cardId,
	},
});

export const CARD_BLUR = 'state.actions.cards.focus.CARD_BLUR' as const;

export type CardBlur = {
	type: typeof CARD_BLUR;
};

export const cardBlur = () => ({
	type: CARD_BLUR,
});

export type Action = CardFocus | CardBlur;
